<template>
  <div id="ps-event-pricing">
    <div class="pricing-wrapper">
      <div class="pricing-icon bg-contain"></div>
      <div class="pricing-title-wrapper">
        <div class="pricing-title">限時優惠<br>國外卡收款開通費</div>
        <div class="discount">89<span>折</span></div>
      </div>
    </div>
    <h1 class="title-md">申請國外卡輸入折扣碼『slash11off』享 89 折優惠</h1>
    <p class="title-xs">
      *國外卡收款開通費原價為新台幣 3,000 元整。<br>
      *此優惠期限至 2025/06/30 止，INSTO（台灣盈士多股份有限公司）保留最後優惠更動權利。<br>
      *國外卡申請將由 INSTO（台灣盈士多股份有限公司）審核，本公司有賣家申請最終審核權利。<br>
      *申請國外卡前請詳閱<a href="https://tap.ins.to/terms/foreign-card.html" target="_blank">國外卡交易注意事項</a>。
    </p>
    <div class="action-button-wrapper">
      <button class="action-button"  v-on:click="download()" id="ps-click-pricing-acbtn">
        下載體驗快速收款
      </button>
      <a href="https://merchant.ins.to/insto-apply/signup/" target="_blank" id="ps-click-pricing-apply-web">
      <button class="action-button">
        立即線上申請
      </button>
    </a>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
      download() {
      const modal = document.getElementById('ps-event-modal')
      modal.classList.add('show')
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/main.scss";
  @import "@/assets/sass/personal-slashie.scss";

#ps-event-pricing {
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #F6FAFB;
  h1 {
    margin-top: 20px;
  }
  @media screen and (max-width: 1552px) {
    padding: 60px 100px;
  }
  @media screen and (max-width: 1024px) {
    padding: 50px;
  }
  @media screen and (max-width: 768px) {
    padding: 40px 20px;
  }
  p {
    line-height: 2;
    text-align: left;
    a {
      color: #2371ff;
      text-decoration: underline;
    }
  }
}

.pricing-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  .pricing-icon {
    width: 154px;
    height: 200px;
    background-image: url('../../assets/imgs/event/personal-slashie/pricing-icon.svg');
    margin-right: 20px;
  }
  .pricing-title-wrapper {
    color: #00C8FF;
    text-align: left;
    .pricing-title {
      font-size: 28px;
      font-weight: 900;
      @media screen and (max-width: 515px) {
        font-size: 20px;
        margin-bottom: 20px;
      }
    }
    .discount {
      margin-top: -25px;
      font-size: 130px;
      font-weight: 900;
      @media screen and (max-width: 515px) {
        font-size: 100px;
      }
      span {
        font-size: 26px;
        @media screen and (max-width: 515px) {
           font-size: 20px;
         }
      }
    }
  }
}

#ps-click-pricing-acbtn {
  margin-right: 0;
}
</style>
